import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

interface CreateExportJobArgs {
  nodeIds: string[];
}

/**
 * Mutation hook to kick off an async ZIP export job.
 * Returns the new export_job_id on success.
 */
export function useCreateExportJobMutation() {
  const { files } = useDomainServices();

  return useMutation<{ export_job_id: string }, Error, CreateExportJobArgs>({
    mutationFn: ({ nodeIds }) => files.createExportJob(nodeIds),
  });
}
